<div class="compliance-overview flex-column d-flex gap-4" *transloco="let t; prefix: 'compliance.library'">
  <div class="compliance-overview__header">
    <div class="header">
      <h2 class="h3 m-0">{{ t('title') }}</h2>
    </div>
		<div>
			<input type="file" hidden #excelFileInput accept=".xlsx,.xls,.csv" (change)="onExcelFileSelectedAsync($event)">
			<app-compliance-filters [isComplianceLibrary]="true" [hasComplianceRegionBtn]="false" [hasComplianceStandardBtn]="false" (addCustomClicked)="onAddCustomCompliance()" (uploadExcelClicked)="excelFileInput.click()" (downloadTemplateClicked)="onDownloadTemplateClicked()"></app-compliance-filters>
		</div>
  </div>

  <div class="row">
    <div class="col-lg-3 col-md-6 col-sm-12">
      <app-non-compliant-widget></app-non-compliant-widget>
    </div>
    <div class="col-lg-3 col-md-6 col-sm-12">
      <app-expiring-soon-widget></app-expiring-soon-widget>
    </div>
    <div class="col-lg-3 col-md-6 col-sm-12">
      <app-compliant-widget></app-compliant-widget>
    </div>
    <div class="col-lg-3 col-md-6 col-sm-12">
      <app-inspection-pass-rate-widget></app-inspection-pass-rate-widget>
    </div>
  </div>

  <div class="cmn_tabWrap">
		<div class="cmn_tabWrapUl">
    	<ul class="nav nav-pills" id="pills-tab" role="tablist">
      	<li class="nav-item" role="presentation">
        	<button class="nav-link active" [class.active]="isTabActive('compliances')"
						id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#pills-home"
          	type="button" role="tab" aria-controls="pills-home" aria-selected="true"
          	(click)="onTabChange('compliances')">
						{{ t('tabs.compliances') }}
					</button>
      	</li>
      	<li class="nav-item" role="presentation">
        	<button class="nav-link" [class.active]="isTabActive('archive')"
						id="pills-profile-tab" data-bs-toggle="pill" data-bs-target="#pills-profile"
          	type="button" role="tab" aria-controls="pills-profile" aria-selected="false"
          	(click)="onTabChange('archive')">
						{{ t('tabs.archive') }}
					</button>
      	</li>
    	</ul>
  	</div>
	</div>

  <div class="tab-content-wrapper">
  	@switch(selectedTab) {
    	@case('compliances') {
    		<app-compliances></app-compliances>
    	}
    	@case('archive') {
    		<app-archive></app-archive>
    	}
  	}
	</div>
</div>